<template>
  <div id="app">
    <div v-if="!saharaOnlineService">
      <section class="hero is-dark is-fullheight bg-cover">
        <div class="hero-body">
          <div class="container has-text-centered">
            <div class="column is-6 is-offset-3">
              <span class="title has-text-grey has-text-centered">
                <router-link to="/">
                  <img
                    class
                    src="./assets/images/logos/brand-logo-white.png"
                    width="80%"
                    alt
                  />
                </router-link>

                <!-- <hr> -->
              </span>
            </div>
            <br />
            <p>
              <strong
                >البوابة الإلكترونية موقوفة مؤقتاً لغرض التحديث، <br />
                و سيتم تشغيلها على تمام الساعة السابعة <br />
                من صباح يوم الأحد 20-10-2019م.</strong
              >
            </p>
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
      />
      <nav
        class="navbar z1 has-shadow is-spaced hint"
        role="navigation"
        aria-label="main navigation"
        v-if="
          $route.name !== 'login' &&
          $route.name !== 'changePassword' &&
          $route.name !== 'signup' &&
          $route.name !== 'maintenance' &&
          $route.name !== 'verify' &&
          $route.name !== 'book' &&
          $route.name !== 'bookingsuccess' &&
          !loggedIn
        "
               style="z-index:1!important;"

      >
        <div class="navbar-brand">
          <router-link to="/" class="logo">
            <img class src="~/./assets/images/logos/brand-logo.png" alt />
            <!-- <span class="mr-5 has-text-link has-text-bold">TEST ENV</span> -->
          </router-link>
          <!-- <span class="navbar-burger burger" data-target="navbarMenu">
          <span></span>
          <span></span>
          <span></span>
          </span>-->
        </div>
        <div
          class="
            is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd
          "
        >
          <Slide>
            <a class="has-text-white is-medium is-size-4-mobile pr-80"
              >الرئيسية</a
            >
            <a
              class="has-text-white is-medium is-size-4-mobile pr-80"
              href="#services"
              >الخدمات</a
            >

            <a
              class="has-text-white is-medium is-size-4-mobile pr-80"
              href="#features"
              >المميزات</a
            >
            <div class="buttons">
              <router-link to="/login">
                <a class="button info-btn has-text-bold is-shadowless">
                  <strong>تسجيل الدخول</strong>
                </a>
              </router-link>
            </div>
          </Slide>
        </div>
        <div id="navbarBasicExample" class="navbar-menu">
          <div class="navbar-end">
            <a class="navbar-item">الرئيسية</a>
            <a class="navbar-item" href="#services">الخدمات</a>

            <a class="navbar-item" href="#features">المميزات</a>

            <div class="navbar-item">
              <div class="buttons">
                <router-link to="/login">
                  <a class="button info-btn has-text-bold is-shadowless">
                    <strong>تسجيل الدخول</strong>
                  </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <!-- <a
        @click="loginfifa"
        class="has-text-black"
        v-if="
          $route.name !== 'login' &&
          $route.name !== 'signup' &&
          $route.name !== 'maintenance' &&
          $route.name !== 'verify' &&
          $route.name !== 'book' &&
          $route.name !== 'bookingsuccess' &&
          !loggedIn
        "
      >
        <nav style="background-color: rgb(243,244,246); margin-bottom: -13px">
          <img class src="~/./assets/images/OlympicParis.jpg" width="1200"/></nav
      ></a> -->
      <nav
        class="navbar has-shadow is-spaced hint z1"
        role="navigation"
        aria-label="main navigation"
        v-if="loggedIn && $route.name !== 'terms'"
        style="z-index:1!important;"
      >
        <div class="navbar-brand">
          <router-link to="/" class="logo">
            <img class src="~/./assets/images/logos/brand-logo.png" alt />
          </router-link>
        </div>
        <div
          class="
            is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd
          "
        >
          <Slide>
            <div class="has-text-left">
              <router-link to="/portal">
                <a class="has-text-white is-medium is-size-4-mobile pr-80">
                  <i class="sl sl-icon-globe navbar-icon"></i> الخدمات
                </a>
              </router-link>
            </div>
            <router-link to="/profile">
              <a class="has-text-white is-medium is-size-4-mobile pr-80">
                <i class="sl sl-icon-user navbar-icon"></i> الحساب
              </a>
            </router-link>
            <router-link to="/notifications">
              <a class="has-text-white is-medium is-size-4-mobile pr-80">
                <i class="sl sl-icon-bell navbar-icon"></i> التنبيهات
              </a>
            </router-link>
            <router-link to="/orders">
              <a class="has-text-white is-medium is-size-4-mobile pr-80">
                <i class="sl sl-icon-layers navbar-icon"></i> الطلبــات
              </a>
            </router-link>

            <div class="buttons">
              <router-link to="/logout" class="pr-80 pt-20">
                <a class="button is-rounded is-danger is-shadowless">
                  <strong>تسجيل الخروج</strong>
                </a>
              </router-link>
            </div>
          </Slide>
        </div>
        <div id="navbarBasicExample" class="navbar-menu">
          <div class="navbar-end">
            <a class="navbar-item">
              <router-link to="/portal">
                <a class="nav-item nav-icon nav-inner is-medium padding-10">
                  <i class="sl sl-icon-globe navbar-icon"></i> الخدمات
                </a>
              </router-link>
            </a>
            <a class="navbar-item">
              <router-link to="/profile">
                <a class="nav-item nav-icon nav-inner is-medium padding-10">
                  <i class="sl sl-icon-user navbar-icon"></i> الحساب
                </a>
              </router-link>
            </a>
            <a class="navbar-item">
              <router-link to="/notifications">
                <a
                  href="#"
                  class="nav-item nav-icon nav-inner is-medium padding-10"
                >
                  <i class="sl sl-icon-bell navbar-icon"></i> التنبيهات
                </a>
              </router-link>
            </a>

            <a class="navbar-item">
              <router-link to="/orders">
                <a
                  href="#"
                  class="nav-item nav-icon nav-inner is-medium padding-10"
                >
                  <i class="sl sl-icon-layers navbar-icon"></i> طلباتى
                </a>
              </router-link>
            </a>
            <div class="navbar-item">
              <div class="buttons">
                <router-link to="/logout">
                  <a
                    class="
                      button
                      is-rounded is-danger is-outlined is-shadowless
                    "
                  >
                    <strong>تسجيل الخروج</strong>
                  </a>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <router-view />
      <footer
        class="footer footer-light-left is-hidden-mobile"
        v-if="$route.name !== 'signup' && $route.name !== 'maintenance' && $route.name !== 'verify' && !loggedIn"
      >
        <!-- <footer class="footer footer-light-left" > -->
        <div class="container">
          <div class="columns is-vcentered">
            <!-- Column -->
            <div class="column is-6">
              <div class="mb-20">
                <img
                  class="small-footer-logo"
                  src="~/./assets/images/logos/brand-logo.png"
                  alt
                />
              </div>
              <div>
                <span class="moto"
                  >Elshaden Technical & Consulting Services Ltd</span
                >
              </div>
            </div>
            <!-- Column -->
            <div class="column">
              <div class="footer-nav-right">
                <a class="footer-nav-link">
                  <router-link to="/" class="has-text-black"
                    >الرئيسية</router-link
                  >
                </a>
                <a class="footer-nav-link">
                  <router-link to="/login" class="has-text-black"
                    >تسجيل الدخول</router-link
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <!-- <div class="bottom-bar is-hidden-desktop" >
      <div class="columns is-mobile ">
        <router-link class="column" to="/food" active-class="bottom-bar-is-active">
          <i class="fa fa-home"></i>
          <p class="has-text-centered has-text-bold">
            <b>الخدمات</b>
          </p>
        </router-link>
        <router-link class="column" to="/orders" active-class="bottom-bar-is-active">
          <i class="fa fa-bell"></i>

          <p class="has-text-centered has-text-bold">
            <b>التنبيهات</b>
          </p>
        </router-link>
  
      </div>
      </div>-->

      <footer class="footer footer-light-left is-hidden-mobile" v-if="loggedIn && $route.name !== 'terms'">
        <!-- <footer class="footer footer-light-left" > -->
        <div class="container">
          <div class="columns is-vcentered">
            <!-- Column -->
            <div class="column is-6">
              <div class="mb-20">
                <img
                  class="small-footer-logo"
                  src="~/./assets/images/logos/brand-logo.png"
                  alt
                />
              </div>
              <div>
                <span class="moto"
                  >Elshaden Technical & Consulting Services Ltd</span
                >
              </div>
            </div>
            <!-- Column -->
            <div class="column">
              <div class="footer-nav-right">
                <a class="footer-nav-link">
                  <router-link to="/portal" class="has-text-black"
                    >الخدمات</router-link
                  >
                </a>
                <a class="footer-nav-link">
                  <router-link to="/profile" class="has-text-black"
                    >الحساب</router-link
                  >
                </a>

                <a class="footer-nav-link">
                  <router-link to="/notifications" class="has-text-black"
                    >التنبيهات</router-link
                  >
                </a>

                <a class="navbar-item">
                  <router-link to="/orders" class="has-text-black"
                    >الطلبات</router-link
                  >
                </a>
                <a class="footer-nav-link">
                  <router-link to="/logout" class="has-text-black"
                    >تسجيل الخروج</router-link
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<style>
#app {
  font-family: "Tajawal", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  /* font-weight: bold; */
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>


<script>
// import Requestname from "@/components/Requestname.vue";
import { Slide } from "vue-burger-menu";
export default {
  components: {
    Slide, // Register your component
  },
  data() {
    return {
      loggedIn: false,
      user: "",
      saharaOnlineService: true,
    };
  },
  mounted() {
    // var user = JSON.parse(localStorage.getItem("user"));

    window.addEventListener("beforeunload", this.leaving);
    window.addEventListener("load", this.new);

    localStorage.getItem("token") != null
      ? (this.loggedIn = true)
      : (this.loggedIn = false);

    if (localStorage.getItem("token") == null) {
      this.loggedIn = false;
    }

    if (this.loggedIn) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }

    Event.$on("login", () => {
      this.loggedIn = true;
    });

    Event.$on("clearsession", () => {
      this.loggedIn = false;
      localStorage.clear();
      // this.$router.push("/");
    });

    Event.$on("logout", () => {
      this.loggedIn = false;
    });
  },
  methods: {
    leaving() {
      this.loggedIn = false;
      localStorage.clear();
      Event.$emit("logout");
    },
    new() {
      Event.$emit("clearsession");
    },
    loginfifa() {
      this.$router.push({
        name: "login",
        params: {
          fifa: true,
        },
      });
    },
  },
};
</script>